import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  background: (p) => p.palette.error[700],
  color: (p) => p.palette.common.white,
};

export const text: SxStyle = {
  color: (p) => p.palette.common.white,
};
